import { Fragment } from "react";

function DataTableFilter({ onFilterClick }) {
  return (
    <Fragment>
      <div
        style={{
          display: "flex",
          padding: "6px",
          background: "#EBF5FF",
          borderRadius: "6px",
          alignItems: "center",
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/filter.svg`}
          alt="Filter"
          onClick={onFilterClick}
          style={{ cursor: "pointer" }}
        />
      </div>
    </Fragment>
  );
}

export default DataTableFilter;
